import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
import { hash } from 'rsvp';

export default class Finals50Route extends Route
{
	@service store;

	model()
	{
		return hash(
		{
			event: this.modelFor('event'),
			events: this.store.findAll('Event'),
		});
	}
}
